import React, { useMemo, useState } from "react";

import { Select } from "components/Select";

import { useItemSearchOptions } from "hooks/useItemSearchOptions";

/**
 * Селект товара с серверным поиском.
 * onChange получает (option, item) — item с полными данными (prices, measureid...).
 */
export const ItemSelect = ({
  label = "Товар",
  labelWidth,
  labelVariant,
  value,
  onChange,
  width = 480,
  placeholder = "Выберите товар",
  isClearable = true,
}) => {
  const [search, setSearch] = useState("");
  const { items, options, isLoading } = useItemSearchOptions(search, value);

  const selectedOption = useMemo(
    () =>
      options.find((o) => String(o.value) === String(value ?? "")) || null,
    [options, value]
  );

  return (
    <Select
      label={label}
      labelWidth={labelWidth}
      labelVariant={labelVariant}
      options={options}
      value={selectedOption}
      isLoading={isLoading}
      isSearchable
      isClearable={isClearable}
      width={width}
      placeholder={placeholder}
      onInputChange={setSearch}
      filterOption={null}
      onChange={(option) => {
        const item = option
          ? items.find((i) => String(i.itemid) === String(option.value))
          : null;
        onChange?.(option, item);
      }}
    />
  );
};
